// extracted by mini-css-extract-plugin
module.exports = {"Tooltip":"mexico_Tooltip__32wO-","Indicador":"mexico_Indicador__W_taQ","FadeIn":"mexico_FadeIn__BGCoJ","fadeIn":"mexico_fadeIn__2UhE4"};